import { usePromiseTracker } from 'react-promise-tracker';

const Spinner = () => {
  const { promiseInProgress } = usePromiseTracker();
  const loadingElement = document.getElementById('loading');
  const isManualLoading = loadingElement?.classList.contains('manual-loading');

  return (
    <div
      id="loading"
      className={`loading ${isManualLoading ? 'loading manual-loading' : !promiseInProgress ? 'spinner-disable' : ''}`}
    >
      <div className="battery" id="battery">
        <div className="liquid" id="liquid"></div>
      </div>
    </div>
  );
};

export default Spinner;
